module.exports = __webpack_public_path__ + "static/media/switch_icon.5d0ea895.svg";